import { create } from 'zustand'

interface IVStore {
    isLoading: boolean;
    currentMode: string;
    currentFloor: string | null;
    isMobile: boolean;
    message: string;

    setIsLoading: (isLoading: boolean) => void;
    setCurrentMode: (currentMode: string) => void;
    setCurrentFloor: (currentFloor: string | null) => void;
    setIsMobile: (isMobile: boolean) => void;
    sendMessage: (message: string) => void;
}

const VStore = create<IVStore>((set) => ({
    isLoading: true,
    currentMode: 'free',
    currentFloor: null,
    isMobile: false,
    message: '',

    setIsLoading: (isLoading: boolean) => set(() => ({ isLoading })),
    setCurrentMode: (currentMode: string) => set(() => ({ currentMode })),
    setCurrentFloor: (currentFloor: string | null) => set(() => ({ currentFloor })),
    setIsMobile: (isMobile: boolean) => set(() => ({ isMobile })),
    sendMessage: (message: string) => set(() => ({ message })),
}));

export default VStore;
